import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import GeneralReportContMain from "presentation/view/container/GeneralReport/GeneralReportContMain";

CommonEntrypoint(<GeneralReportContMain />)